import React, { useEffect, useState } from 'react';
import Amplify, { Auth, Hub } from 'aws-amplify';
import jwt from 'jsonwebtoken';
import awsconfig from '../.aws-config/awsconfig'
import awsauth from '../.aws-config/awsauth'
import config from '../config';

Amplify.configure(awsconfig)
Auth.configure({ oauth: awsauth })

const Landing = () => {
  const [user, setUser] = useState(null);
  
  const defaultRoute = () => {
    if (user) {
      const params = {
        sub: user.attributes.sub,
        name: user.attributes.name,
        email: user.attributes.email,
        picture: user.attributes.picture,
        identities: user.attributes.identities
      }
      const encryptUserLogin = jwt.sign(params, config.JWT.SECRETKEY);
      console.log(encryptUserLogin)
      //set cookie expire in 1 day
      document.cookie = `prwwu=${encryptUserLogin};expires=${new Date(Date.now() + 86400000).toUTCString()};domain=${config.COOKIE.DOMAIN};path=/`

      // check if callback url cookie exist
      if (document.cookie.indexOf('cb') !== -1) {
        const cb_cookie = document.cookie.split(';').find(c => c.trim().startsWith('cb='));
        const cb_value = cb_cookie.split('=')[1];

        if (cb_value) {
          window.location = document.cookie.replace(/(?:(?:^|.*;\s*)cb\s*=\s*([^;]*).*$)|^.*$/, "$1");
        }
      } else {
        window.location = 'https://golive-asia.com/';
      }  
    }
  }

  useEffect(() => {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      // eslint-disable-next-line default-case
      switch (event) {
        case 'signIn':
        case 'cognitoHostedUI':
          getUser()
            .then(userData => setUser(userData))
          break;
        case 'signOut':
          setUser(null);
          // console.log('signed out');
          break;
        case 'signIn_failure':
        case 'cognitoHostedUI_failure':
          console.log('Sign in failure', data);
          break;
      }
    });

    getUser().then(userData => setUser(userData));
  }, []);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then(userData => userData)
      .catch(() => console.log('Not signed in'));
  }

  return (
    <>
      {defaultRoute()}
    </>
  );
}

export default Landing;